import { Directive, AfterViewInit, inject, Input, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appIntegerOnly]',
    standalone: false
})
export class IntegerOnlyDirective implements AfterViewInit {
  @Input('appIntegerOnly') enabled?: boolean = false;
  private ngControl = inject(NgControl);
  private destroyRef = inject(DestroyRef);

  ngAfterViewInit(): void {
    if (this.enabled) {
      this.ngControl.valueChanges?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: string) => {
        let initialValue = value;
        if (typeof value === 'string') {
          // Allow only integers (0-9), exclude all other characters
          initialValue = value.replace(/[^0-9]/g, '');
        }
        if (value !== initialValue) {
          this.ngControl.control?.setValue(initialValue, { emitEvent: false });
        }
      });
    }
  }
}